export default "__VITE_ASSET__ab7b798f__"